// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerWithHeader_container__3kNuk","header":"ContainerWithHeader_header__d4rHS","content":"ContainerWithHeader_content__h8q_Z"};